import React, { FC, useEffect, useState } from 'react';
import cls from 'classnames';
import { MagnifyingGlassIcon, XBoldIcon } from '@stashinvest/react-assets';
import { SearchEntryProps } from './SearchEntry.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import ButtonIcon from '../../button/buttonIcon';

export const classNames = getClassNames('sds-search-entry', [
	'is-enabled',
	'search-icon',
	'clear-icon',
	'has-text',
]);

const SearchEntry: FC<SearchEntryProps> = (props) => {
	const { inputName, text = '', isEnabled, onTextChanged } = props;

	const [internalText, setInternalText] = useState(text);

	useEffect(() => {
		if (onTextChanged) onTextChanged(internalText);
	}, [internalText]);

	useEffect(() => {
		setInternalText(text);
	}, [text]);
	const hasText = internalText !== '';
	return (
		<div
			className={cls(getRootClassListFromProps(classNames, props), {
				[classNames.hasText]: hasText,
			})}
		>
			<input
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setInternalText(e.currentTarget.value);
				}}
				value={internalText}
				placeholder={inputName}
				disabled={!isEnabled}
			/>
			<div>
				<div className={classNames.searchIcon}>
					<MagnifyingGlassIcon size="XS" />
				</div>

				{hasText && (
					<div className={classNames.clearIcon}>
						<ButtonIcon
							variant="secondary"
							Icon={XBoldIcon}
							size="small"
							onClick={() => setInternalText('')}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

SearchEntry.displayName = 'SearchEntry';

export default SearchEntry;
